import { render, staticRenderFns } from "./recommendMerchant.vue?vue&type=template&id=3ff9a35e&scoped=true&"
import script from "./recommendMerchant.vue?vue&type=script&lang=js&"
export * from "./recommendMerchant.vue?vue&type=script&lang=js&"
import style0 from "./recommendMerchant.vue?vue&type=style&index=0&id=3ff9a35e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff9a35e",
  null
  
)

export default component.exports